import EnabledIcon from '@/CustomIcons/EnabledIcon'
import StopIcon from '@/CustomIcons/StopIcon'
import { cn } from '@/utlis/cn'

type EnabledIndicatorProps = {
    enabled: boolean
    className?: string
}
export function EnabledIndicator(props: EnabledIndicatorProps) {
    return (
        <div
            className={cn(
                'py-[8px] px-[11px] border-muse-toplit-low shadow-glow rounded-[12px] flex items-center gap-[1px] t-sm-light',
                !props.enabled && 'text-muse-fg/65',
                props.className
            )}
        >
            {props.enabled ? (
                <EnabledIcon className="text-[#85E0A3]" style={{ fontSize: '1.3rem' }} />
            ) : (
                <StopIcon className="text-[#FC7840]" style={{ fontSize: '1.3rem' }} />
            )}
            {props.enabled ? 'ON' : 'OFF'}
        </div>
    )
}
